module.exports = __webpack_public_path__ + "static/media/Yathaarth Bhansali.651b9d4c.png";